import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/main.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import Upload from '../../component/Inc/Upload';
import Calendar from '../../component/Inc/Calendar';
import PopRecommend from './_PopRecommend';
//chart
import LineChart from '../../component/Inc/LineChart';

function Index() {
  const navigate = useNavigate();
  const [modalChattingOpen, setModalChattingOpen] = useState(false);
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '자격증', cnt: '45', value: 0},
    {title: '캠페인', cnt: '9898', value: 1},
    {title: '시상', cnt: '233', value: 2},
    {title: '승인 완료', cnt: '45', type: ' blue', value: 3},
    {title: '미승인', cnt: '53', type: ' red', value: 4}
  ];
  //chart data
  const lineChartWidth = '100%';
  const lineChartHeight = '147px';
  const labels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
  const data = {
    lineChartlabels: labels,
    datasets: [
      {
        label: 'Dataset 2',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  return (
    <main className="com_container p_main">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu0_1">김교사507 교사</h2>
          <button onClick={() => setModalChattingOpen(true)} className="com_btn orange s btn_plus">
            내용 등록
          </button>
        </section>
        <section className="com_pg_container">
          <div className="box">
            <h2 className="detail_tit dot">- 입력폼 com_input_sec</h2>
            <ul className="com_input_sec">
              <li className="tit_field">새로운 비밀번호를 입력해 주세요.</li>
              <li className="input_field">
                <div className="com_input_wrap">
                  <input type="password" placeholder="영문, 숫자, 특수문자 포함 8~16 자리" />
                </div>
                <span className="error_txt">* 전화번호 형식이 정확하지 않습니다.</span>
              </li>
              <li className="input_field">
                <div className="com_input_wrap flex_row">
                  <input type="text" placeholder="입력하세요" className="input" />
                  <input type="text" placeholder="입력하세요" className="input" />
                </div>
              </li>
            </ul>
            <h2 className="detail_tit dot">- File upload</h2>
            <div className="com_input_upload">
              <Upload title="파일 등록" className="com_btn gray xs wl" />
              <p className="file">
                <span className="txt">File name.pdf</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
                <button type="button" className="btn_down" onClick={() => {}}></button>
              </p>
            </div>

            <h2 className="detail_tit dot">- board list type_row</h2>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="25%" />
                <col width="25%" />
                <col width="25%" />
                <col width="25%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>현 보유 포인트</th>
                  <td className="td_point">1,224,000</td>
                  <th>총 포인트</th>
                  <td className="td_point">1,224,000</td>
                </tr>
                <tr>
                  <th>직급 가점</th>
                  <td className="td_point">65,456</td>
                  <th>필요 가점</th>
                  <td className="td_red">4,300</td>
                </tr>
              </tbody>
            </table>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="28%" />
                <col width="60%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>주차장 명</th>
                  <td>
                    <input type="text" className="input" defaultValue={`강남주차장`} />
                  </td>
                </tr>
                <tr>
                  <th>방문구분</th>
                  <td>
                    <select className="select">
                      <option value="수업 - 영어">수업 - 영어</option>
                      <option value="방문">방문</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>방문사유</th>
                  <td>
                    <input type="text" className="input" defaultValue={`하승유 스터디카페 수업`} />
                  </td>
                </tr>
                <tr>
                  <th>입차시간</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <select className="select">
                        <option value="18시">18시</option>
                        <option value="17시">17시</option>
                      </select>
                      <select className="select">
                        <option value="30분">30분</option>
                        <option value="00분">00분</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>출차시간</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <select className="select">
                        <option value="18시">18시</option>
                        <option value="17시">17시</option>
                      </select>
                      <select className="select">
                        <option value="30분">30분</option>
                        <option value="00분">00분</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>청구금액</th>
                  <td>
                    <input type="text" className="input" defaultValue={`78,000`} />
                  </td>
                </tr>
              </tbody>
            </table>
            <Paging />

            <hr className="com_divider" />
            <h2 className="detail_tit dot">- board list</h2>
            <div className="com_board_list__top type_column">
              <section className="com_board_search">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="10%" />
                <col width="12%" />
                <col width="12%" />
                <col width="12%" />
                <col width="12%" />
                <col width="12%" />
              </colgroup>
              <thead>
                <tr>
                  <th>요청일</th>
                  <th>요청자</th>
                  <th>수업</th>
                  <th>
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                    입차시간
                  </th>
                  <th>청구액</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2022.08.25 12:30</td>
                  <td>
                    <button onClick={() => navigate('/Student/Attendance/Detail')} className="name btn_link">
                      김요청103
                    </button>
                  </td>
                  <td>영어</td>
                  <td>2022.08.25 12:30</td>
                  <td>800,000</td>
                  <td className="td_red">
                    승인불가 <br />
                    2022,09,25
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>2022.08.25 12:30</td>
                      <td>
                        <button className="name btn_link">김요청103</button>
                      </td>
                      <td>영어</td>
                      <td>2022.08.25 12:30</td>
                      <td>800,000</td>
                      <td className="td_point">
                        승인완료 <br />
                        2022,09,25
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="box">
            <span className="com_check_box">
              <input type="checkbox" name="chk" id="chk010" className="com_chk" />
              <label htmlFor="chk010">원거리 강의 가능</label>
            </span>
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <p>
                  댓글 <span className="cnt">10</span>
                </p>
                <span className="dot" />
                <p>
                  조회 <span className="cnt">321</span>
                </p>
              </div>
            </div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_edit" />
                <button className="btn_delete" />
              </div>
            </div>
            <div className="com_detail_top">
              <button className="state">배정 요청</button>
              <div className="info">
                <p className="tit">홍길동104</p>
                <span className="dot"></span>
                <p className="date">2023.05.20 11:30</p>
              </div>
            </div>
            <div className="com_detail_top">
              <button className="state stop">인계</button>
              <div className="info stop">
                <p className="tit">인계3</p>
                <span className="dot"></span>
                <p className="txt">교사의 불성실 사유로 인한 중단</p>
              </div>
            </div>
            <div className="com_detail_top">
              <button className="state">1차 보고서</button>
              <div className="info">
                <p className="tit">생기부 디자인 컨설팅 (제안) 보고서</p>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">완성여부</span>
                  <span className="cont">Y</span>
                </div>
              </div>
              <div className="board_subject name">학생 내신 정보</div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon red">배정담당자</span>
                    <span className="com_icon red">이의신청</span>
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">제 생각은 다릅니다. 이의신청합니다..</div>
              </div><br/>
							<div className="com_notice_box"><p>notice box</p>
							<button className="com_btn xs orange">value</button>
							</div>
            </div>
            {/*comment*/}
            <div className="com_comment_wrap">
              <div className="com_input_wrap flex_row">
                <select className="select">
                  <option value="이의신청">이의신청</option>
                </select>
                <select className="select">
                  <option value="1수업 상태 변경">1수업 상태 변경</option>
                </select>
                <select className="select">
                  <option value="2수업 상태 변경">2수업 상태 변경</option>
                </select>
              </div>
              <textarea className="textarea" placeholder="내용을 입력해주세요"></textarea>
            </div>

            <div className="com_comment_wrap">
              <div className="com_input_wrap flex_row">
                <select className="select">
                  <option value="수업정보 수정">수업정보 수정</option>
                </select>
                <select className="select">
                  <option value="메시지 확인자 선택">메시지 확인자 선택</option>
                </select>
              </div>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>

            <div className="com_comment_wrap">
              <ul className="comment_list">
                <li className="item">
                  <div className="info">
                    <p className="name">홍길동104</p>
                    <span className="dot" />
                    <p className="date">2023.05.20 11:30</p>
                    <div className="com_btn_wrap">
                      <button className="btn_edit"></button>
                      <button className="btn_delete"></button>
                    </div>
                  </div>
                  <p className="txt">
                    축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!
                    <br />
                    축하드려요~!
                  </p>
                </li>
              </ul>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>

            <h2 className="detail_tit dot">-버튼 com_btn</h2>
            <div className="com_btn_wrap">
              <button className="com_btn orange l">버튼 60px</button>
              <button className="com_btn gray m">버튼 50px</button>
              <button className="com_btn red s">버튼 40px</button>
              <button className="com_btn black xs">버튼 36px</button>
            </div>
            <div className="com_btn_wrap">
              <button className="com_btn line orange l">버튼 60px</button>
              <button className="com_btn line gray m">버튼 50px</button>
              <button className="com_btn line red s">버튼 40px</button>
              <button className="com_btn line black xs">버튼 36px</button>
            </div>
						<div className="com_btn_wrap">
						<button className="btn_del_file"></button>
						<button className='btn_calendar'></button>
						<button className='btn_calendar_dark'></button>
						<button className='btn_comments'></button>
						<button className='btn_seen'></button>
						<button className='btn_icon_tick_with_text'></button>
						<button className='btn_price_line'></button>
						<button className='btn_special'></button>
						<button className='btn_list'></button>
						<button className='btn_heart'></button>
						<button className='btn_down'></button>
						<button className='btn_down_orange'></button>
						<button className='btn_down_circle'></button>
						<button className='btn_message'></button>
						</div>
            <h2 className="detail_tit dot">- input</h2>
            <div className="com_input_wrap">
              <div className="sec_input">
                <select className="select">
                  <option value="지점선택">지점선택</option>
                  <option value="지점선택">지점선택</option>
                </select>
              </div>
              <div className="sec_input">
                <input type="text" placeholder="입력하세요" className="input" />
              </div>
              <div className="sec_input">
                <input type="text" placeholder="입력하세요" className="input error" />
              </div>
              <div className="sec_input">
                <textarea placeholder="입력하세요" className="textarea" />
              </div>
            </div>
            <h2 className="detail_tit dot">Tab Component</h2>
            <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="arrow_s" />
            <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="s" />

            <h2 className="detail_tit dot" style={{marginTop: '30px'}}>
              달력
            </h2>
            <div className="date_wrap">
              <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
              <span className="divider"> ~ </span>
              <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
            </div>
            <div className="date_wrap">
              <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
              <select className="select" style={{width: '100px'}}>
                <option value="18시">18시</option>
                <option value="19시">19시</option>
              </select>
              <select className="select" style={{width: '100px'}}>
                <option value="30분">30분</option>
                <option value="00분">00분</option>
              </select>
              <button className="com_btn line gray m">검색</button>
            </div>
            <h2 className="detail_tit dot" style={{marginTop: '30px'}}>
              검색 search
            </h2>
            <div className="search_wrap">
              <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
              <button className="com_btn gray s ws icon_search"></button>
              <button className="com_btn orange xs icon_search"></button>
            </div>
            <h2 className="detail_tit dot" style={{marginTop: '30px'}}>
              checkbox/radio
            </h2>
            <div className="check">
              <input type="checkbox" id="chk01" className="com_chk" />
              <label htmlFor="chk01">ID저장</label>
            </div>
            <div className="check">
              <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
              <label htmlFor="rdo01">라디오1라디오1라디오1라디오1</label>
              <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
              <label htmlFor="rdo02">라디오2</label>
            </div>
            <div className="com_check_date">
              <input type="checkbox" className="chk_date" id="mon" defaultChecked />
              <label htmlFor="mon">월</label>
              <input type="checkbox" className="chk_date" id="tue" />
              <label htmlFor="tue">화</label>
              <input type="checkbox" className="chk_date" id="wed" />
              <label htmlFor="wed">수</label>
              <input type="checkbox" className="chk_date" id="thu" />
              <label htmlFor="thu">목</label>
              <input type="checkbox" className="chk_date" id="fri" />
              <label htmlFor="fri">금</label>
              <input type="checkbox" className="chk_date" id="sat" />
              <label htmlFor="sat">토</label>
              <input type="checkbox" className="chk_date" id="sun" />
              <label htmlFor="sun">일</label>
            </div>
            <h2 className="detail_tit dot" style={{marginTop: '30px'}}>
              상태 card
            </h2>
            <div className="com_status_box">
              <div className="item">
                <p className="tit">희망 수업수</p>
                <button className="com_btn gray xxs">수정</button>
                <p className="num">50</p>
              </div>
              <div className="item">
                <p className="tit">목표 수업수</p>
                <button className="com_btn gray xxs">수정</button>
                <p className="num">460</p>
              </div>
              <div className="item">
                <p className="tit">진행 수업수</p>
                <p className="num">78</p>
              </div>
              <div className="item red">
                <p className="tit">진행률</p>
                <p className="num">87.5%</p>
              </div>
            </div>
          </div>
          <div className="box">
            <h2 className="detail_tit dot">Calendar</h2>
            <Calendar />
            <Calendar type="salary" />
            {/*좌,우측에 옵션이 있는 경우*/}
            <div className="com_calendar_wrap has_option">
              <div className="option">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
              </div>
              <div className="year ">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
              <div className="com_count_wrapper">
                <div className="operators">
                  <div className="operators_label">
                    <span className="operators_count">총 영업자 수</span>
                    <span className="operators_value">98명</span>
                  </div>
                </div>
                <div className="turnover">
                  <div className="turnover_label">
                    <span className="turnover_count">총 매출액</span>
                    <span className="turnover_value">46,500,000</span>
                  </div>
                </div>
              </div>
            </div>

            <h2 className="detail_tit dot">Chart</h2>
            <div style={{width: 400}}>
              <LineChart data={data} width={lineChartWidth} height={lineChartHeight} />
            </div>
            <h2 className="detail_tit dot">counter</h2>
            <div className="com_flex_row">
              <button className="btn_add_gray"></button>
              <button className="btn_minus_gray"></button>
              <input type="text" className="input" value="4567000" />
            </div>
            <div className="com_flex_row">
              <button className="btn_add_black"></button>
              <button className="btn_minus"></button>
              <input type="text" className="input" value="4567000" />
            </div>
            <div className="com_flex_row">
              <button className="btn_add_dark_gray"></button>
              <input type="text" className="input" value="4567000" />
            </div>
						<div className="com_count_updown">
                    <button className="arrow down"></button>
                   1
                    <button className="arrow up"></button>
            </div>
          </div>
        </section>
      </div>
      <PopRecommend open={modalChattingOpen} close={() => setModalChattingOpen(false)} />
    </main>
  );
}

export default Index;
